import React from "react";
import PropTypes from "prop-types";
import { TaskNotificationsTemplate } from 'themes/application/dashboard/components';
import { observer } from 'mobx-react';

@observer
class TaskNotifications extends React.Component {
    render() {
        return <TaskNotificationsTemplate {...this.props} />;
    }
}

TaskNotifications.propTypes = {
    title: PropTypes.string,
    data: PropTypes.object
};

export default TaskNotifications;
